import cookies from "vue-cookies"
const ProjFn = {
    getToken: () => {
        return (cookies as any).get("token")
    },
    setToken: (token) => {
        (cookies as any).set("token", token)
    },
    removeToken: () => {
        (cookies as any).remove("token")
    },
    getGuid: () => {
        return (cookies as any).get("guid")
    },
    setGuid: (guid) => {
        (cookies as any).set("guid", guid, 60 * 60 * 24)
    },
    removeGuid: () => {
        (cookies as any).remove("guid")
    }
}

export default ProjFn;
